import { t, Trans } from "@lingui/macro";
import React from "react";

import { ToggleSwitch } from "@whoosh/design-system/src/components/controls";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { PreferencesType } from "./ManageNotifications";

type MyBookingsProps = {
  preferences: PreferencesType;
  handleChange: (name: keyof PreferencesType) => void;
};

export const MyBookings = ({ preferences, handleChange }: MyBookingsProps) => {
  return (
    <VStack gap={3}>
      <Text variant="mainTiny" color={"text-secondary"}>
        <Trans>MY BOOKINGS</Trans>
      </Text>
      <HStack justifyContent="space-between" alignItems="center">
        <Text variant="mainSmall">{t`Updates`}</Text>
        <ToggleSwitch
          name="bookingUpdatesEnabled"
          onToggle={() => handleChange("bookingUpdatesEnabled")}
          isChecked={preferences.bookingUpdatesEnabled}
          isDisabled={false}
          accessibilityLabel={t`Toggle booking update notifications`}
        />
      </HStack>
      <HStack justifyContent="space-between" alignItems="center">
        <Text variant="mainSmall">{t`Reminders`}</Text>
        <ToggleSwitch
          name="bookingRemindersEnabled"
          onToggle={() => handleChange("bookingRemindersEnabled")}
          isChecked={preferences.bookingRemindersEnabled}
          isDisabled={false}
          accessibilityLabel={t`Toggle booking reminder notifications`}
        />
      </HStack>
    </VStack>
  );
};
